export default {
    staff: {},
    isViewMobile: false,
    partakers: {
        data: [],
        metadata: {},
        hasViewed: false
    },
    staffs: {
        data: [],
        metadata: {},
        hasViewed: false
    },
    payouts: {
        data: [],
        metadata: {}
    },
    coupons: {
        data: [],
        metadata: {},
        hasViewed: false
    }
}